<template>
  <Carousel
    :perPage="1"
    navigationEnabled
    :paginationEnabled="false"
    loop
    :centerMode="true"
    :value="value"
  >
    <Slide v-for="(item, index) in items" :key="`slide-item-${index}`">
      <div class="h-full flex items-center">
        <img :src="item" class="mx-auto max-h-80">
      </div>
    </Slide>
  </Carousel>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'ItemCarousel',
  components: {
    Carousel,
    Slide
  },
  props: {
    items: {
      type: Array
    },
    value: {
      type: Number,
      default: 1
    }
  }
} 
</script>
<style lang="scss" scoped>
@mixin btn-Carousel {
  @apply w-10 h-10 -mt-5;
  font-size: 0;
  transform: translate(0);
  transition: 0.5s;
  &:hover {
    @apply bg-theme;
    transition: 0.5s;
    &:before {
      transition: 0.5s;
    }
  }
  &:focus {
    @apply outline-none;
  }
  &:before {
    @apply w-4 h-4 absolute border-l border-b border-black;
    content: "";
    top: 12px;
  }
}
/deep/.VueCarousel-navigation {
  .VueCarousel-navigation-prev {
    @include btn-Carousel;
    &:before {
      transform: rotate(45deg);
      left: 15px;
    }
  }
  .VueCarousel-navigation-next {
    @include btn-Carousel;
    &:before {
      transform: rotate(-135deg);
      right: 15px;
    }
  }
}
</style>
